import React from "react";
import { Translate } from "components/common/Translate/Translate";
import { X } from "lucide-react";
import { useFreeDowngradeMessage } from "@/modules/Dashboard/Dashboard/hooks/useFreeDowngradeMessage";
import { useActiveSubscriptionQuery } from "@/modules/Dashboard/Pricing/useActiveSubscriptionQuery";
import useSubscription from "@/modules/Dashboard/Pricing/useSubscription";

const IncompleteStatusMessageBanner = () => {
    const { data } = useActiveSubscriptionQuery();
    const { handleManageAction } = useSubscription();

    if (data?.result?.status !== "incomplete") {
        return null;
    }

    return (
        <div
            className="flex dark:text-white right-1 bg-warning/30 dark:bg-warning/20  p-4 mt-8 rounded-lg text-sm text-center cursor-pointer"
            onClick={() => {
                handleManageAction({
                    activeSubscriptionId: data?.result?.stripeSubscriptionId,
                });
            }}
        >
            <span className="w-full text-lg text-red-800  dark:text-red-100">
                <Translate keyName={"incomplete-payment-toast-message"} />
            </span>
        </div>
    );
};

export default IncompleteStatusMessageBanner;
